<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div>
                        <h3>
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Activacion de usuario
                        </h3>
                        <p>Su cuenta se ha activado satisfactoriamente</p>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="login__form">
                    <div class="login__paragraph">
                        <p>Su cuenta se ha activado satisfactoriamente</p>
                    </div>
                    <button class="button-principal" @click="$router.push({ path: '/' })">Ir al login</button>
                </div>
            </b-col>
            <b-col>
                <div class="login__logo">
                    <img :src="$cdn + '/logos/logo-Cajasan-azul-slogan.png'" alt="Logo Cajasan">
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'formActivate',
  data () {
    return {
    }
  }
}
</script>
